import {
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Switch,
} from '@chakra-ui/react';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { useFormContext } from 'react-hook-form';

export function FixedCustomerForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();

  const allowFallbackFieldPath = fieldPath('allowFallback');

  return (
    <FormControl>
      <Flex alignItems="center" gap={2} mb={1}>
        <Switch
          id={allowFallbackFieldPath}
          {...form.register(allowFallbackFieldPath)}
        />
        <FormLabel htmlFor={allowFallbackFieldPath} mb={0}>
          Allow Fallback
        </FormLabel>
      </Flex>
      <FormHelperText>
        When enabled, passes down to the next price strategy if quantity exceeds
        this strategy's maximum quantity break.
      </FormHelperText>
    </FormControl>
  );
}
